import api from '@/api';
import { ItemLabelRequest, ItemLabelResponse } from './items-label.types';
import { API_BASE_URL } from '..';

const BASE_API = `${API_BASE_URL}/items/label`;

export default {
  async list(params?: ItemLabelRequest) {
    const result = (await api.get(BASE_API, params)) as unknown;
    return result as ItemLabelResponse;
  },
};
